import { render } from "./ColorComponent.vue?vue&type=template&id=4d21b914"
import script from "./ColorComponent.vue?vue&type=script&lang=js"
export * from "./ColorComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__